/* Lorivano padel — comportements des sections lv-* (accueil + fiche produit).
   Chaque section porte data-lv="<composant>" et est initialisée par init(). Ré-initialisée dans l'éditeur de thème. */
(function () {
  'use strict';
  var LV = window.LV = window.LV || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var t = function (k, d) { return (LV.i18n && LV.i18n[k]) || d; };

  /* ---------- utilitaires ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) {
    var fmt = LV.moneyFormat || '£{{amount}}';
    var n = Number(cents) / 100;
    function group(x, dec, th, ds) {
      var p = x.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.length > 1 ? p[0] + ds + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        case 'amount_with_space_separator': return group(n, 2, ' ', ',');
        default: return group(n, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  LV.money = money;
  var ARR = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'lv-toast'; toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg><span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent = msg; toastEl.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.hidden = true; }, 2600);
  }
  LV.toast = toast;

  /* ---------- dialogues partagés ---------- */
  function dialog(id, extraClass) {
    var d = document.getElementById(id);
    if (!d) {
      d = document.createElement('dialog');
      d.id = id; d.className = 'lv lv-dialog ' + (extraClass || '');
      d.innerHTML = '<div class="lv-dlg"><button class="lv-x" type="button" data-lv-close aria-label="' + esc(t('close', 'Close')) + '">' + X + '</button><div data-lv-body></div></div>';
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-lv-close]')) d.close(); });
      document.body.appendChild(d);
    }
    return d;
  }
  function openDialog(d) { if (d && d.showModal && !d.open) d.showModal(); }
  function showInDialog(html, label) {
    var d = dialog('lv-dlg-generic');
    d.querySelector('[data-lv-body]').innerHTML = html;
    if (label) d.setAttribute('aria-label', label);
    openDialog(d); return d;
  }
  function zoom(src, alt, cap) {
    var d = dialog('lv-dlg-zoom', 'lv-zoomd');
    d.querySelector('.lv-dlg').style.padding = '0';
    d.querySelector('[data-lv-body]').innerHTML = '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '">' + (cap ? '<p>' + esc(cap) + '</p>' : '');
    openDialog(d);
  }
  LV.zoom = zoom;

  /* ---------- panier ---------- */
  function cartUrl(p) { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + p; }
  function refreshCount() {
    return fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-lv-cart-count]').forEach(function (n) {
        n.textContent = c.item_count; n.hidden = !c.item_count;
        n.classList.remove('lv-pop'); void n.offsetWidth; n.classList.add('lv-pop');
      });
      return c;
    });
  }
  function addToCart(variantId, qty, btn, name) {
    if (!variantId) return;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.dataset.sectionId ? [drawer.dataset.sectionId] : [];
    if (btn) btn.classList.add('is-loading');
    fetch(cartUrl('cart/add.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }], sections: sections.join(',') })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); })
      .then(function (res) {
        return refreshCount().then(function (c) {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: { itemCount: c.item_count, source: 'lorivano', sections: res.sections } } }));
          if (drawer && LV.openCartOnAdd) document.dispatchEvent(new CustomEvent('cart:open'));
          else toast((name ? name + ' ' : '') + t('added', 'added to your basket'));
        });
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  LV.addToCart = addToCart;

  /* ---------- apparition au défilement ---------- */
  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function reveal(root) {
    if (!io || (window.Shopify && Shopify.designMode)) return;
    root.querySelectorAll('.lv-rv').forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight) io.observe(el); });
  }

  /* ---------- gamme de raquettes (collection d'accueil) ---------- */
  function getRange() {
    var el = document.querySelector('[data-lv-range]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function specRows(p) {
    return Object.keys(p.specs || {}).map(function (k) {
      var v = p.specs[k];
      if (v == null && !LV.demo) return '';
      return '<li><b>' + esc(k) + ':</b> ' + (v == null ? '<span class="lv-pend">' + esc(t('pending', 'pending')) + '</span>' : esc(v)) + '</li>';
    }).join('');
  }
  function limitOf(p) { return p.limit || (p.demo ? '' : finderProfile(p).limit); }
  function quickView(p) {
    var d = showInDialog('<div class="lv-qv"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '"><div class="lv-qv__info"><h2>' + esc(p.name) + '</h2><p style="font-size:24px;font-weight:700;color:var(--lv-ink)">' + esc(money(p.price)) + (p.demo ? ' <span class="lv-pill">' + esc(t('illustrative', 'Illustrative')) + '</span>' : '') + '</p>' + (p.blurb ? '<p>' + esc(p.blurb) + '</p>' : '') + '<ul>' + specRows(p) + '</ul>' + (limitOf(p) ? '<p><b>' + esc(t('limit', 'Limit')) + ':</b> ' + esc(limitOf(p)) + '</p>' : '') +
      (p.demo || !p.variantId ? '' : '<button class="lv-btn lv-btn--green" type="button" data-lv-qv-add' + (p.available ? '' : ' disabled') + '>' + esc(p.available ? t('addTo', 'Add to basket') + ' — ' + money(p.price) : t('soldOut', 'Sold out')) + '</button>') +
      (p.url ? '<a class="lv-ulink" href="' + esc(p.url) + '">' + esc(t('fullDetails', 'See full details')) + ' ' + ARR + '</a>' : '') +
      '<a class="lv-ulink" href="#lv-finder" data-lv-close>' + esc(t('notSure', 'Not sure? Take the guide')) + '</a></div></div>', p.name);
    var add = d.querySelector('[data-lv-qv-add]');
    if (add) add.addEventListener('click', function () { addToCart(p.variantId, 1, add, p.name); d.close(); });
  }
  function compare(ps) {
    if (!ps.length) return;
    var keys = Object.keys(ps[0].specs || {});
    var head = '<tr><th scope="col"><span class="lv-vh">Feature</span></th>' + ps.map(function (p) { return '<th scope="col"><img src="' + esc(p.img) + '" alt=""><br>' + esc(p.name) + '</th>'; }).join('') + '</tr>';
    var rows = '<tr><th scope="row">' + esc(t('price', 'Price')) + '</th>' + ps.map(function (p) { return '<td>' + esc(money(p.price)) + '</td>'; }).join('') + '</tr>';
    rows += '<tr><th scope="row">' + esc(t('bestFor', 'Best for')) + '</th>' + ps.map(function (p) { return '<td>' + esc(p.blurb) + '</td>'; }).join('') + '</tr>';
    keys.forEach(function (k) {
      var any = ps.some(function (p) { return p.specs[k] != null; });
      if (!any && !LV.demo) return;
      rows += '<tr><th scope="row">' + esc(k) + '</th>' + ps.map(function (p) { return '<td>' + (p.specs[k] == null ? '<span class="lv-pend">' + esc(t('pendingCap', 'Pending')) + '</span>' : esc(p.specs[k])) + '</td>'; }).join('') + '</tr>';
    });
    rows += '<tr><th scope="row">' + esc(t('limit', 'Limit')) + '</th>' + ps.map(function (p) { return '<td>' + esc(limitOf(p)) + '</td>'; }).join('') + '</tr>';
    rows += '<tr><td></td>' + ps.map(function (p) { return '<td><button class="lv-btn lv-btn--green" type="button" data-lv-qv="' + esc(p.id) + '" style="min-height:44px;padding:0 16px;font-size:15px">' + esc(t('explore', 'Explore')) + '</button></td>'; }).join('') + '</tr>';
    var d = showInDialog('<h2>' + esc(t('compareTitle', 'Compare rackets')) + '</h2><div class="lv-tbox"><table class="lv-ctable"><thead>' + head + '</thead><tbody>' + rows + '</tbody></table></div>' + (LV.demo ? '<p style="font-size:13px">' + esc(t('compareNote', 'Details marked pending are being confirmed.')) + '</p>' : ''), t('compareTitle', 'Compare rackets'));
    d.querySelectorAll('[data-lv-qv]').forEach(function (b) { b.addEventListener('click', function () { var p = byId(b.dataset.lvQv); d.close(); if (p) quickView(p); }); });
  }
  function byId(id) { return getRange().filter(function (p) { return String(p.id) === String(id); })[0]; }

  var components = {};

  components.header = function (root) {
    var mb = root.querySelector('[data-lv-menu]'), mn = root.querySelector('[data-lv-mnav]');
    if (mb && mn) {
      mb.addEventListener('click', function () { var o = mb.getAttribute('aria-expanded') === 'true'; mb.setAttribute('aria-expanded', String(!o)); mn.hidden = o; });
      mn.addEventListener('click', function (e) { if (e.target.closest('a')) { mn.hidden = true; mb.setAttribute('aria-expanded', 'false'); } });
    }
    var sb = root.querySelector('[data-lv-search-btn]'), sbox = root.querySelector('[data-lv-search]');
    if (sb && sbox) sb.addEventListener('click', function () { var o = !sbox.hidden; sbox.hidden = o; sb.setAttribute('aria-expanded', String(!o)); if (!o) sbox.querySelector('input').focus(); });
    var bag = root.querySelector('[data-lv-bag]');
    if (bag) bag.addEventListener('click', function (e) {
      if (document.querySelector('cart-drawer')) { e.preventDefault(); document.dispatchEvent(new CustomEvent('cart:open')); }
    });
    root.querySelectorAll('[data-lv-loc-select]').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
    if (root.hasAttribute('data-lv-transparent')) {
      var solid = function () {
        var open = (mn && !mn.hidden) || (sbox && !sbox.hidden) || root.matches(':hover') || root.contains(document.activeElement);
        root.classList.toggle('lv-is-solid', window.scrollY > 10 || open);
      };
      window.addEventListener('scroll', solid, { passive: true });
      ['mouseenter', 'mouseleave', 'focusin', 'focusout', 'click'].forEach(function (ev) { root.addEventListener(ev, function () { setTimeout(solid, 0); }); });
      solid();
    }
  };

  components.collection = function (root) {
    var tray = root.querySelector('[data-lv-tray]');
    function selected() { return Array.prototype.map.call(root.querySelectorAll('[data-lv-cmp]:checked'), function (c) { return byId(c.dataset.lvCmp); }).filter(Boolean); }
    function updateTray() {
      var s = selected(), go = tray.querySelector('[data-lv-tray-go]');
      tray.classList.toggle('is-on', s.length > 0);
      tray.querySelector('[data-lv-tray-t]').textContent = s.length + ' ' + t('selected', 'selected');
      go.disabled = s.length < 2;
      go.textContent = s.length < 2 ? t('pickOne', 'Pick one more') : t('compare', 'Compare') + ' (' + s.length + ')';
    }
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-lv-cmp]')) return;
      if (e.target.checked && selected().length > 3) { e.target.checked = false; toast(t('maxThree', 'Compare up to three rackets')); }
      updateTray();
    });
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-lv-qv]'); if (q) { var p = byId(q.dataset.lvQv); if (p) quickView(p); return; }
      if (e.target.closest('[data-lv-compare-all]')) compare(getRange().slice(0, 3));
      if (e.target.closest('[data-lv-tray-go]')) { var s = selected(); if (s.length >= 2) compare(s); }
      if (e.target.closest('[data-lv-tray-clear]')) { root.querySelectorAll('[data-lv-cmp]').forEach(function (c) { c.checked = false; }); updateTray(); }
    });
    /* page collection (lv-main-collection) : filtres style / poids / budget + tri, côté navigateur */
    if (root.hasAttribute('data-lv-cl')) {
      var grid = root.querySelector('[data-lv-cl-grid]'), empty = root.querySelector('[data-lv-cl-empty]'), countEl = root.querySelector('[data-lv-cl-count]'), sortSel = root.querySelector('[data-lv-cl-sort]');
      var countLabel = countEl ? countEl.textContent.replace(/^\d+\s*/, '') : '';
      var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-lv-cl-item]')) : [];
      var data = {};
      getRange().forEach(function (p) { var pr = finderProfile(p); data[String(p.id)] = { focus: pr.focus, w: pr.w, wclass: pr.w === null ? '' : (pr.light ? 'light' : pr.heavy ? 'heavy' : 'mid'), price: p.price }; });
      function fval(name) { var c = root.querySelector('[data-lv-f="' + name + '"]:checked'); return c ? c.value : ''; }
      function apply() {
        var st = fval('style'), wt = fval('weight'), bd = fval('budget'), shown = 0;
        cards.forEach(function (c) {
          var d = data[c.dataset.lvClItem] || {}, ok = true;
          if (st && d.focus !== st) ok = false;
          if (wt && d.wclass !== wt) ok = false;
          if (bd && Number(c.dataset.price) > Number(bd)) ok = false;
          c.hidden = !ok; if (ok) shown++;
        });
        var mode = sortSel ? sortSel.value : '';
        var sorted = cards.slice().sort(function (a, b) {
          var da = data[a.dataset.lvClItem] || {}, db = data[b.dataset.lvClItem] || {};
          if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (mode === 'weight-asc') return (da.w || 999) - (db.w || 999) || Number(a.dataset.price) - Number(b.dataset.price);
          return Number(a.dataset.index) - Number(b.dataset.index);
        });
        sorted.forEach(function (c) { grid.appendChild(c); });
        if (countEl) countEl.textContent = shown + ' ' + countLabel;
        if (empty) empty.hidden = shown > 0;
      }
      root.addEventListener('change', function (e) { if (e.target.matches('[data-lv-f], [data-lv-cl-sort]')) apply(); });
      var rs = root.querySelector('[data-lv-cl-reset]');
      if (rs) rs.addEventListener('click', function () { root.querySelectorAll('[data-lv-f][value=""]').forEach(function (i) { i.checked = true; }); if (sortSel) sortSel.value = ''; apply(); });
    }
  };

  /* quiz « Racket finder » : gamme réelle de la boutique (data-lv-finder-range), profil déduit de la forme / du poids / du prix.
     mode "range" : meilleure raquette de la gamme ; mode "product" : avis honnête sur la raquette de la fiche (+ alternative). */
  function finderProfile(p) {
    var shape = String(p.shape || '').toLowerCase(), feats = (p.features || []).join(' ').toLowerCase();
    var m = String(p.weight || '').match(/\d{3}/), w = m ? parseInt(m[0], 10) : null;
    var dia = shape.indexOf('diamond') !== -1 || (!shape && feats.indexOf('diamond') !== -1);
    var rnd = shape.indexOf('round') !== -1 || (!shape && feats.indexOf('round') !== -1);
    var focus = dia && !rnd ? 'power' : (rnd && !dia ? 'easy' : 'all');
    var light = w !== null && w <= 350, heavy = w !== null && w >= 365;
    var levels = focus === 'power' ? ['regular', 'experienced'] : focus === 'easy' ? ['starting', 'regular'] : ['starting', 'regular', 'experienced'];
    if (focus === 'power' && light) levels.unshift('starting');
    if (heavy) levels = levels.filter(function (l) { return l !== 'starting'; });
    var lim = focus === 'power' ? t('limPower', 'Diamond shape: less forgiving on off-centre hits than a round head.') :
      focus === 'easy' ? t('limEasy', 'Round head: more control and comfort, a little less punch on smashes.') :
      t('limAll', 'An all-rounder: it doesn’t specialise in power or in control.');
    if (heavy) lim += ' ' + t('limHeavy', 'At about') + ' ' + w + ' g ' + t('limHeavy2', 'it asks a little more of your arm on long sessions.');
    else if (light && focus === 'power') lim += ' ' + t('limLightPower', 'Light for a diamond: easy to swing, a little less weight behind the ball.');
    return { focus: focus, levels: levels, w: w, light: light, heavy: heavy, limit: lim };
  }

  components.quiz = function (root) {
    var form = root.querySelector('form'), steps = form.querySelectorAll('.lv-qstep'), next = root.querySelector('[data-lv-next]'), back = root.querySelector('[data-lv-back]');
    var res = root.querySelector('[data-lv-result]'), side = root.querySelector('[data-lv-side]'), count = root.querySelector('[data-lv-count]'), bar = root.querySelector('.lv-segs b');
    var mode = root.dataset.mode, step = 0, N = steps.length;
    var cfg = {}; try { cfg = JSON.parse(root.querySelector('[data-lv-quiz-config]').textContent); } catch (e) {}
    var RANGE = []; try { RANGE = JSON.parse(root.querySelector('[data-lv-finder-range]').textContent); } catch (e) {}
    RANGE.forEach(function (p) { p.pr = finderProfile(p); });
    var B = cfg.budgets || [10000, 12000], BUNDLE = cfg.bundle;
    function val(i) { var c = form.querySelector('input[name="q' + i + '"]:checked'); return c ? c.value : null; }
    function nextLabel(s) { return esc(s) + ' ' + ARR; }
    function render() {
      steps.forEach(function (s, i) { s.hidden = i !== step; });
      res.hidden = step !== N; if (side) side.hidden = step === N;
      count.textContent = step === N ? t('yourResult', 'Your result') : (step + 1) + ' ' + t('of', 'of') + ' ' + N;
      root.querySelectorAll('.lv-segs i').forEach(function (s, i) { s.classList.toggle('is-on', i <= Math.min(step, N - 1)); });
      if (bar) bar.style.width = (Math.min(step + 1, N) / N * 100) + '%';
      back.hidden = step === 0;
      next.disabled = step < N && !val(step);
      next.innerHTML = step === N ? esc(t('again', 'Start again')) : nextLabel(step === N - 1 ? t('seeResult', 'See my result') : t('continue', 'Continue'));
    }
    form.addEventListener('change', function () { if (step < N) next.disabled = !val(step); });
    next.addEventListener('click', function () {
      if (step < N - 1) { step++; render(); var f = steps[step].querySelector('input'); if (f) f.focus(); return; }
      if (step === N - 1) { finish(); return; }
      reset(null);
    });
    back.addEventListener('click', function () { step = step === N ? N - 1 : Math.max(0, step - 1); render(); });
    function reset(start) {
      form.reset();
      var v = start && start !== '0' ? start : 'rental';
      var r = form.querySelector('input[name="q0"][value="' + v + '"]'); if (r) r.checked = true;
      step = 0; render();
    }
    function li(s) { return '<li>' + s + '</li>'; }
    function maxBudget(v) { return v === 'b1' ? B[0] : v === 'b2' ? B[1] : Infinity; }
    function fill(s, p) {
      var q = BUNDLE.duoQty || 2, off = BUNDLE.duoOff || 0, full = p.price * q;
      return String(s || '').replace(/\[percent\]/g, off + ' %').replace(/\[qty\]/g, q).replace(/\[full\]/g, money(full)).replace(/\[total\]/g, money(Math.round(full * (100 - off) / 100)));
    }

    function score(p, a) {
      var level = (a.now === 'new' || a.freq === 'low') ? 'starting' : (a.freq === 'high' ? 'experienced' : 'regular');
      var want = a.want === 'unsure' ? 'all' : a.want, max = maxBudget(a.budget), pr = p.pr, s = 0, why = [];
      if (a.now === 'rental') why.push(t('whyRental', 'Your own racket means the same feel every session.'));
      if (a.now === 'own') why.push(t('whyOwn', 'A change from your current racket: compare its weight with yours.'));
      if (pr.focus === want) {
        s += 3;
        why.push(want === 'power' ? t('whyPower', 'You want more power: its diamond shape puts the weight high for attacking shots.') :
          want === 'easy' ? t('whyEasy', 'You want something easy to handle: its round head is the most forgiving shape.') :
          (a.want === 'unsure' ? t('whyUnsure', 'You’re not sure yet: an all-rounder doesn’t push you towards one style.') : t('whyAll', 'You want a bit of everything, which is what an all-round racket aims for.')));
      } else if (want === 'all') s += 1;
      if (want === 'easy' && pr.light) { s += 1; why.push(t('whyLight', 'At about') + ' ' + pr.w + ' g ' + t('whyLight2', 'it stays light in the hand.')); }
      if (want === 'power' && pr.heavy) { s += 1; why.push(t('whyHeavy', 'At about') + ' ' + pr.w + ' g ' + t('whyHeavy2', 'it has weight behind the ball.')); }
      if (pr.levels.indexOf(level) !== -1) { s += 2; why.push(level === 'starting' ? t('lvlStart', 'It suits players starting to play regularly.') : level === 'regular' ? t('lvlReg', 'It suits regular players.') : t('lvlExp', 'It suits frequent players.')); } else s -= 2;
      if (p.price <= max) why.push(t('fitsBudget', 'It fits your budget') + ' (' + money(p.price) + ').'); else s -= 4;
      return { p: p, s: s, why: why };
    }
    function rank(a) { return RANGE.map(function (p) { return score(p, a); }).sort(function (x, y) { return y.s - x.s || x.p.price - y.p.price; }); }

    function specLine(p) { return [p.shape, p.weight, p.construction].filter(Boolean).map(esc).join(' · '); }
    function featList(p) {
      var f = (p.features || []).filter(function (x) { return !/return|trial|refund/i.test(x); }).slice(0, 3);
      return f.length ? '<ul class="lv-qfeat">' + f.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '';
    }
    function bundleBox(p, a) {
      if (!BUNDLE) return '';
      var duo = a.who === 'duo', h = '';
      if (BUNDLE.duoOff > 0) {
        h += duo ? '<div class="lv-qdeal lv-qdeal--on"><b>' + esc(fill(BUNDLE.duoTitle, p)) + '</b><span>' + esc(fill(BUNDLE.duoText, p)) + '</span></div>'
          : '<p class="lv-qdeal"><span>' + esc(fill(BUNDLE.duoTeaser, p)) + '</span></p>';
      }
      if (BUNDLE.gifts && BUNDLE.gifts.length) {
        var worth = BUNDLE.gifts.reduce(function (n, g) { return n + g.price; }, 0);
        h += '<div class="lv-qgifts"><b>' + esc(BUNDLE.giftsTitle) + '</b><div>' + BUNDLE.gifts.map(function (g) {
          return '<span class="lv-qgift">' + (g.img ? '<img src="' + esc(g.img) + '" alt="" width="36" height="36" loading="lazy">' : '') + '<span>' + esc(g.name) + ' <s>' + esc(money(g.price)) + '</s></span></span>';
        }).join('') + '</div>' + (BUNDLE.gifts.length > 1 ? '<small>' + esc(t('giftsWorth', 'Worth')) + ' ' + esc(money(worth)) + '</small>' : '') + '</div>';
      }
      return h;
    }
    function card(best, a, eyebrow) {
      var p = best.p;
      return (eyebrow ? '<span class="lv-eyebrow">' + esc(eyebrow) + '</span>' : '') +
        '<div class="lv-qresult__top">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="84" height="84">' : '') + '<div><h3>' + esc(p.name) + '</h3><b>' + esc(money(p.price)) + '</b>' + (p.compare > p.price ? ' <s>' + esc(money(p.compare)) + '</s>' : '') + (specLine(p) ? '<small class="lv-qspec">' + specLine(p) + '</small>' : '') + '</div></div>' +
        '<ul>' + best.why.slice(0, 3).map(function (w) { return li(esc(w)); }).join('') + '</ul>' + featList(p) +
        '<p class="lv-lim"><b>' + esc(t('tradeoff', 'Trade-off')) + ':</b> ' + esc(p.pr.limit) + ' ' + esc(t('noGuide', 'No guide can tell you exactly how a racket feels in your hand.')) + '</p>' +
        bundleBox(p, a);
    }
    function cta(p, label) { return '<a class="lv-btn lv-btn--green lv-qcta" href="' + esc(p.url) + '">' + esc(label || (BUNDLE && BUNDLE.cta) || (t('explore', 'Explore') + ' ' + p.name)) + ' ' + ARR + '</a>'; }
    function alsoLink(alt) { return alt ? '<p class="lv-qalt">' + esc(t('alsoLook', 'Also worth a look:')) + ' <a href="' + esc(alt.p.url) + '">' + esc(alt.p.name) + '</a> · ' + esc(money(alt.p.price)) + '</p>' : ''; }

    function finishRange(a) {
      if (a.now === 'new' && a.freq === 'low') {
        return '<h3>' + esc(t('rentTitle', 'Renting a little longer may suit you')) + '</h3><ul>' + li(esc(t('rent1', 'You’re just starting and play less than once a week.'))) + li(esc(t('rent2', 'A few more games will show you what you prefer.'))) + '</ul><p class="lv-lim">' + esc(t('rent3', 'Come back once padel is a regular habit. No pressure.')) + '</p>';
      }
      if (!RANGE.length) return '<h3>' + esc(t('noRange', 'No rackets to recommend yet')) + '</h3>';
      var r = rank(a), best = r[0], alt = r[1] && r[1].s >= 3 ? r[1] : null;
      if (best.s < 3) {
        return '<h3>' + esc(t('noneTitle', 'None of our rackets clearly fits')) + '</h3><ul>' + li(esc(best.p.price > maxBudget(a.budget) ? t('none1', 'The closest match is above the budget you chose.') : t('none2', 'Your answers point to something our range doesn’t cover well.'))) + li(esc(t('none3', 'We’d rather say so than force a match.'))) + '</ul><p class="lv-lim">' + esc(t('none4', 'Try changing your budget, or ask us.')) + '</p>' + alsoLink(best);
      }
      return card(best, a, t('ourPick', 'Our pick for you')) + cta(best.p) + alsoLink(alt);
    }
    function finishProduct(a) {
      var cur = cfg.current || {}, r = rank(a);
      var mine = r.filter(function (x) { return String(x.p.id) === String(cur.id); })[0];
      if (!mine) return finishRange(a);
      var best = r[0];
      if (best === mine || mine.s >= best.s - 1) {
        var alt = r.filter(function (x) { return x !== mine && x.s >= 3; })[0];
        return card(mine, a, t('suggestion', 'Our suggestion')) + '<a class="lv-btn lv-btn--green lv-qcta" href="#lv-buy">' + esc((BUNDLE && BUNDLE.cta) || (t('see', 'See') + ' ' + cur.short)) + ' ' + ARR + '</a>' + alsoLink(alt);
      }
      return '<span class="lv-eyebrow">' + esc(t('honest', 'Our honest answer')) + '</span><p class="lv-qhonest">' + esc(t('honest1', 'From your answers,')) + ' <b>' + esc(best.p.name) + '</b> ' + esc(t('honest2', 'fits you better than')) + ' ' + esc(cur.short) + '. ' + esc(t('talk2', 'We’d rather say so than sell you the wrong one.')) + '</p>' + card(best, a) + cta(best.p, t('see', 'See') + ' ' + best.p.name);
    }
    function finish() {
      var a = { now: val(0), freq: val(1), want: val(2), budget: val(3), who: N > 4 ? val(4) : 'me' };
      res.innerHTML = mode === 'product' ? finishProduct(a) : finishRange(a);
      step = N; render(); res.focus({ preventScroll: true });
    }
    root.lvStart = reset;
    render();
  };

  components.guides = function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lv-guide]'); if (!b) return;
      var tpl = root.querySelector('template[data-lv-guide-body="' + b.dataset.lvGuide + '"]');
      if (tpl) showInDialog(tpl.innerHTML, b.querySelector('b') ? b.querySelector('b').textContent : '');
    });
  };

  /* fiche produit : galerie, variantes, ajout panier, barre collante */
  components.product = function (root) {
    var data = {}; try { data = JSON.parse(root.querySelector('[data-lv-product-json]').textContent); } catch (e) {}
    var variants = data.variants || [];
    var stage = root.querySelector('[data-lv-stage-img]'), thumbs = root.querySelectorAll('[data-lv-thumb]'), cur = 0;
    function show(i) {
      if (!thumbs.length) return;
      cur = (i + thumbs.length) % thumbs.length;
      var th = thumbs[cur];
      stage.classList.add('is-fade');
      setTimeout(function () { stage.src = th.dataset.src; stage.removeAttribute('srcset'); stage.alt = th.dataset.alt || ''; stage.classList.remove('is-fade'); }, 180);
      thumbs.forEach(function (x, j) { x.setAttribute('aria-pressed', String(j === cur)); });
    }
    thumbs.forEach(function (x, j) { x.addEventListener('click', function () { show(j); }); });
    root.querySelectorAll('[data-lv-step]').forEach(function (b) { b.addEventListener('click', function () { show(cur + parseInt(b.dataset.lvStep, 10)); }); });
    if (stage) {
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
      stage.addEventListener('dblclick', function () { zoom(stage.currentSrc || stage.src, stage.alt); });
    }
    var zb = root.querySelector('[data-lv-zoom-stage]');
    if (zb) zb.addEventListener('click', function () { zoom(stage.currentSrc || stage.src, stage.alt); });

    var idInput = root.querySelector('[data-lv-variant-id]'), adds = document.querySelectorAll('[data-lv-add="' + root.dataset.section + '"]');
    function current() { var id = idInput ? Number(idInput.value) : null; return variants.filter(function (v) { return v.id === id; })[0]; }
    function updateUI(v) {
      var price = v ? v.price : data.price, available = v ? v.available : false;
      document.querySelectorAll('[data-lv-price="' + root.dataset.section + '"]').forEach(function (el) { el.textContent = money(price); });
      document.querySelectorAll('[data-lv-compare-at="' + root.dataset.section + '"]').forEach(function (el) { el.hidden = !(v && v.compare_at_price > v.price); if (v && v.compare_at_price) el.textContent = money(v.compare_at_price); });
      var st = root.querySelector('[data-lv-stock]');
      if (st) {
        var status = !available ? 'out_of_stock' : (v.tracked && v.qty > 0 && v.qty <= Number(st.dataset.threshold) ? 'low' : 'in_stock');
        var lbl = status === 'out_of_stock' ? st.dataset.out : status === 'low' ? (st.dataset.showCount === 'true' ? st.dataset.lowCount.replace('[count]', v.qty) : st.dataset.low) : st.dataset.in;
        st.className = 'lv-stock lv-stock--' + status;
        st.querySelector('[data-lv-stock-label]').textContent = lbl;
        var ship = st.querySelector('[data-lv-stock-ship]'); if (ship) ship.hidden = status === 'out_of_stock';
      }
      adds.forEach(function (b) {
        b.disabled = !available;
        var label = b.querySelector('[data-lv-add-label]');
        var addTxt = b.dataset.addLabel || t('addTo', 'Add to basket'), soldTxt = b.dataset.soldLabel || t('soldOut', 'Sold out');
        if (label) label.innerHTML = available ? esc(addTxt) + (b.hasAttribute('data-lv-no-price') ? '' : ' — <span>' + esc(money(price)) + '</span>') : esc(v ? soldTxt : t('unavailable', 'Unavailable'));
      });
      root.querySelectorAll('[data-lv-option-value]').forEach(function (el, i) { if (v) el.textContent = v.options[Number(el.dataset.lvOptionValue)]; });
      if (v && v.featured_media_id) {
        thumbs.forEach(function (x, j) { if (Number(x.dataset.mediaId) === v.featured_media_id) show(j); });
      }
    }
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-lv-option]')) return;
      var chosen = Array.prototype.map.call(root.querySelectorAll('[data-lv-option-group]'), function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      if (idInput) idInput.value = v ? v.id : '';
      updateUI(v);
      if (v && !(window.Shopify && Shopify.designMode)) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    });
    adds.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart(idInput && idInput.value, 1, b, data.title); }); });

    var sticky = document.querySelector('[data-lv-sticky="' + root.dataset.section + '"]'), mainAdd = root.querySelector('[data-lv-main-add]');
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      var setSticky = function (s) { sticky.classList.toggle('is-show', s); sticky.setAttribute('aria-hidden', String(!s)); sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = s ? 0 : -1; }); };
      new IntersectionObserver(function (es) { var e = es[0]; setSticky(!e.isIntersecting && e.boundingClientRect.top < 0); }).observe(mainAdd);
    }
  };

  /* estimation de livraison : jours ouvrés, heure limite, samedi/dimanche exclus selon réglages */
  components.delivery = function (root) {
    var d = root.dataset, min = parseInt(d.minDays, 10) || 0, max = parseInt(d.maxDays, 10) || min;
    var cutoff = d.cutoffHour === '' ? null : parseInt(d.cutoffHour, 10);
    var noSat = d.noSaturday === 'true', noSun = d.noSunday === 'true';
    function closed(x) { var w = x.getDay(); return (w === 6 && noSat) || (w === 0 && noSun); }
    function add(n) {
      var x = new Date();
      if (cutoff !== null && !isNaN(cutoff) && x.getHours() >= cutoff) x.setDate(x.getDate() + 1);
      var added = 0;
      while (added < n) { x.setDate(x.getDate() + 1); if (!closed(x)) added++; }
      while (closed(x)) x.setDate(x.getDate() + 1);
      return x;
    }
    function fmt(x) {
      var o = d.dateFormat === 'numbers' ? { day: '2-digit', month: '2-digit' } : { day: 'numeric', month: 'long' };
      var s = x.toLocaleDateString(d.locale || undefined, o);
      if (d.showWeekday === 'true') { var w = x.toLocaleDateString(d.locale || undefined, { weekday: 'long' }); s = w.charAt(0).toUpperCase() + w.slice(1) + ' ' + s; }
      return s;
    }
    root.querySelector('[data-lv-min-date]').textContent = fmt(add(min));
    root.querySelector('[data-lv-max-date]').textContent = fmt(add(Math.max(min, max)));
  };

  /* avis défilants : fondu, pastilles, pause au survol/focus, arrêt si animations réduites */
  components.quotes = function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.lv-quotes__item'));
    if (items.length < 2) return;
    var index = 0, paused = false, timer = null, delay = Math.max(3000, Number(root.dataset.interval) || 6000);
    var nav = document.createElement('div'); nav.className = 'lv-quotes__dots';
    var dots = items.map(function (_, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'lv-quotes__dot';
      b.setAttribute('aria-label', t('review', 'Review') + ' ' + (i + 1) + ' / ' + items.length);
      b.addEventListener('click', function () { show(i); start(); });
      nav.appendChild(b); return b;
    });
    root.appendChild(nav);
    function show(n) {
      index = ((n % items.length) + items.length) % items.length;
      items.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === index)); });
    }
    function start() {
      if (timer) clearInterval(timer);
      if (reduce) return;
      timer = setInterval(function () { if (!paused && !document.hidden) show(index + 1); }, delay);
    }
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('shopify:block:select', function (e) { var i = items.indexOf(e.target); if (i >= 0) { show(i); paused = true; } });
    document.addEventListener('shopify:block:deselect', function () { paused = false; });
    show(0); start();
  };

  components.looks = function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lv-zoom-src]'); if (!b) return;
      zoom(b.dataset.lvZoomSrc, b.querySelector('img') ? b.querySelector('img').alt : '', b.dataset.lvCaption || '');
    });
  };

  components.calc = function (root) {
    var cS = root.querySelector('[data-lv-sessions]'), cF = root.querySelector('[data-lv-fee]'), price = Number(root.dataset.price) || 0;
    if (!cS || !cF) return;
    function fee() { var f = parseFloat(String(cF.value).replace(',', '.').replace(/[^0-9.]/g, '')); return isNaN(f) ? 0 : f; }
    function calc() {
      var s = Math.max(0, parseInt(cS.value, 10) || 0), perWeek = s * fee() * 100;
      var w = root.querySelector('[data-lv-weeks]'), ws = root.querySelector('[data-lv-weeks-sub]');
      root.querySelector('[data-lv-year]').textContent = money(Math.round(perWeek * 52 / 100) * 100).replace(/[.,]00(?!\d)/, '');
      if (perWeek <= 0) { w.textContent = '—'; ws.textContent = t('noFee', 'With no rental fee, there is nothing to compare.'); return; }
      var weeks = Math.ceil(price / perWeek);
      w.textContent = weeks + ' ' + (weeks === 1 ? t('week', 'week') : t('weeks', 'weeks'));
      ws.textContent = root.dataset.weeksSub;
    }
    cS.addEventListener('input', calc); cF.addEventListener('input', calc);
    cF.addEventListener('blur', function () { cF.value = money(Math.round(fee() * 100)).replace(/[.,]00(?!\d)/, ''); calc(); });
    calc();
  };

  /* ---------- liens globaux ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-lv-start]');
    if (s) {
      var q = document.querySelector('[data-lv="quiz"]');
      if (q && q.lvStart) { e.preventDefault(); q.lvStart(s.dataset.lvStart); q.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }
      return;
    }
    var d = e.target.closest('[data-lv-dialog]');
    if (d) { var dl = document.getElementById(d.dataset.lvDialog); if (dl) { e.preventDefault(); openDialog(dl); } return; }
    var od = e.target.closest('[data-lv-open-details]');
    if (od) { var det = document.getElementById(od.dataset.lvOpenDetails); if (det) det.open = true; }
    var own = e.target.closest('[data-lv-own]');
    if (own) { var qz = document.querySelector('[data-lv="quiz"]'); if (qz && qz.lvStart) qz.lvStart('own'); }
  });
  document.addEventListener('click', function (e) {
    var dl = e.target.closest('dialog.lv-dialog');
    if (dl && (e.target === dl || e.target.closest('[data-lv-close]'))) dl.close();
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-lv]').forEach(function (el) {
      if (el.lvInit) return; el.lvInit = true;
      var c = components[el.dataset.lv]; if (c) c(el);
    });
    reveal(scope || document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
